module.exports = __webpack_public_path__ + "static/media/gluchowski_pointing.e3ccb1be.webp";